import * as React from 'react';
import { styled } from '@linaria/react';

import { Ball, BOUNCE_MAGNITUDE } from './CssVsJs.helpers';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  isPlaying: boolean;
}

function BallKeyframe({
  isPlaying,
  style = {},
  ...delegated
}: Props) {
  return (
    <CssBall
      data-is-playing={isPlaying}
      style={{
        '--bounce-magnitude': BOUNCE_MAGNITUDE + 'px',
        ...style,
      }}
      {...delegated}
    />
  );
}

const CssBall = styled(Ball)`
  @keyframes bounce {
    to {
      transform: translateX(var(--bounce-magnitude));
    }
  }

  animation: bounce 1000ms linear infinite alternate;

  &[data-is-playing='false'] {
    animation-play-state: paused;
  }
`;

export default BallKeyframe;
